import { Ionicon, IoniconHtml } from '@/constants/ionicon';
import * as React from 'react';

type HtmlButtonProps =
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export type CopyButtonProps = {
  target: string;
}&(
  Pick<HtmlButtonProps, Exclude<keyof HtmlButtonProps, 'onClick'|'onKeyPress'|'role'|'tabIndex'|'ref'>>
);

interface CopyButtonState {
  icon: IoniconHtml
}

export class CopyButton extends React.Component<CopyButtonProps, CopyButtonState> {
  constructor(props) {
    super(props);
    this.state = { icon: Ionicon.COPY.toHtml() };
  }

  // eslint-disable-next-line react/destructuring-assignment
  trigger = (customTarget?: string|unknown) => {
    const { target } = this.props;
    window.copyTarget(typeof customTarget === 'string' ? customTarget : target);
    this.setState({ icon: Ionicon.DONE.toHtml() });
    setTimeout(() => this.setState({ icon: Ionicon.COPY.toHtml() }), 1000);
  };

  render() {
    const { target, ...buttonProps } = this.props;
    const { icon } = this.state;

    return (
      <button
        type="button"
        className="copy-button noselect"
        data-copy-target={target}
        onClick={this.trigger}
        onKeyPress={this.trigger}
        {...buttonProps} // eslint-disable-line react/jsx-props-no-spreading
        dangerouslySetInnerHTML={icon} // eslint-disable-line react/no-danger
      />
    );
  }
}
